import sendEvent from './sendEvent'

const sendAffiliateLink = (data) => {
	sendEvent({
		eventCategory: 'affiliate',
		eventAction: 'click',
		eventLabel: data.product,
    eventValue: data.value,
	})
}
export default sendAffiliateLink



// WEBPACK FOOTER //
// ./src/actions/events/sendAffiliateLink.js